import { checkStatus } from '../../utilities/fetch';
import { emailSettingsPath } from '../../utilities/api_relative_paths';

import { XMLHTTPResponse } from '../../utilities/types';

interface Response {
  receives_partner_emails?: boolean;
  opt_out_of_all_emails?: boolean;
}

type EmailSettingResponse = Promise<Response>;
type GetEmailSettingResponse = Promise<boolean>;
type RequestOptions = {
  method: string;
  headers: {
    'Content-Type': 'application/json';
  };
  body?: string;
};

/* GET: Fetches email settings */

const getEmailSetting = (emailSetting: string): GetEmailSettingResponse => {
  return fetch(`${emailSettingsPath}/${emailSetting}`)
    .then((param: XMLHTTPResponse) => checkStatus(param))
    .then((response) => response.json())
    .catch(() => Promise.reject());
};

/* POST/DELETE: Updates email settings */
const updateEmailSetting = (
  permalink: string,
  enabled: boolean,
  email?: string | null
): EmailSettingResponse => {
  const method = enabled ? 'POST' : 'DELETE';

  const requestOptions: RequestOptions = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const referrer = `${window.location.href}`;
  if (email) {
    requestOptions.body = JSON.stringify({ email, referrer });
  }

  return fetch(`${emailSettingsPath}/${permalink}`, requestOptions)
    .then((param: XMLHTTPResponse) => checkStatus(param))
    .then((response) => response.json() as EmailSettingResponse)
    .catch(() => Promise.reject());
};

export { getEmailSetting, updateEmailSetting };
